import { css, type Theme } from "@emotion/react";

import { dimensions, utilities } from "@styles";

export const brandListItem = (logoUrl: string) => (theme: Theme) =>
  css`
    align-items: center;
    background: center / 50% no-repeat url(${logoUrl});
    border-color: ${theme.separator.base};
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 0.5rem;
    width: 100%;

    @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
      background: transparent;
    }
  `;

export const logoName = css`
  @media only screen and (min-width: ${dimensions.tablet}) {
    ${utilities.visuallyHidden}
  }
`;

export const icon = (theme: Theme) => css`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  &&& {
    path {
      color: ${theme.success.textBase};
    }
  }
`;

export const active = (theme: Theme) => css`
  border-color: ${theme.success.borderBase};

  &:hover {
    border-color: ${theme.success.borderHover};
  }
`;
